import Api from '@/services/api';
import qs from 'querystring';

export default {
 
  get() {
    return Api().get('/sellers/list');
  },
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'nom', sortDesc = false, fetchFacets = true) {

    return Api().post('/sellers/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  delete_seller(data) {
    return Api().delete('/seller/' + data.seller_id);
  },
  update_seller(data) {
    return Api().post('/seller/' + data.seller_id, qs.stringify({ data: JSON.stringify(data.seller) }));    
  },
  create_seller(data) {
    return Api().post('/seller' , qs.stringify({ data: JSON.stringify(data.seller) }));    
  },
  seller(data) {
    return Api().get('/seller/' + data.seller_id);
  },
  commissions(data) {
    return Api().get('/seller/' + data.seller_id + '/commissions');
  }
}